import React, { FC, useContext } from 'react';
import { FocusOn } from 'react-focus-on';
import { BrandingLogo } from '../SideNav/BrandingLogo';
import { NavElement } from '../SideNav/NavElement';
import { MenuToggle } from '../SideNav/MenuToggle';
import { NavMenu, NavMenuVariant } from '../SideNav/SideNavTypes';
import { NavContextProvider } from '../SideNav/NavContextProvider';
import { NavigationButtons, NavigationButtonsDesktop } from './NavigationButtons';
import { NavContext } from '../SideNav/NavContext';
import { Banner } from '@trip-ux/components';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { ReduxStore } from '@trip-ux/redux-store';


export const NavigationResponsive: FC<NavMenu> = ({
  branding,
  mobileMenuItem,
  toggleClose,
  toggleOpen,
  languageInfo,
  contactUs,
  menuList,
  isCollapsed,
  isB2C,
  referenceId,
  onSelect,
  onLanguageToggle
}) => {

  const context = useContext(NavContext);
  const delay = 1000;
  const { logo, label } = branding ?? {};
  const {
    contentFragment,
    userProfile,config  } = useSelector((store: ReduxStore) => ({
    contentFragment: store.contentFragment,
    userProfile: store.userProfile,
    whiteLabel: store.userProfile.whiteLabel,
    config: store.config,
  }));

  return context.isMobile && isCollapsed ? (
    <div className={`side-nav-mobile ${context.mobileToggle ? 'show-mobile-drop' : ''}`}>
      <div className={`d-flex flex-row ${context.mobileToggle ? 'inverted' : ''}`} role="menubar">
        <BrandingLogo logo={logo} invertedLogo={logo} label={label} />
        {mobileMenuItem && (
          <NavElement {...mobileMenuItem} className="mobile-item order-2 ml-auto" variant={NavMenuVariant.VERTICAL} />
        )}
        {toggleClose && toggleOpen && (
          <MenuToggle ariaControls="nav-mobile-control" toggleClose={toggleClose} toggleOpen={toggleOpen} />
        )}
      </div>
      {context.mobileToggle && (
        <FocusOn
          enabled={context.mobileToggle}
          autoFocus={true}
          returnFocus={true}
          onClickOutside={e => {
            context.setMobileToggle(false);
            context.setClickedOutside(true);
            setTimeout(function () {
              context.setClickedOutside(false);
            }, delay);
          }}
          onEscapeKey={() => context.setMobileToggle(false)}>
          {
            <NavigationButtons
              contactUs={contactUs}
              languageInfo={languageInfo}
              menuList={menuList}
              onSelect={onSelect}
              onLanguageToggle={onLanguageToggle}
            />
          }
        </FocusOn>
      )}
    </div>
  ) : (
    <div className={`top-nav-responsive d-lg-block ${context.isMobile && !isCollapsed ? '' : 'd-none'}`}>
      {context.isMobile && !isCollapsed ? (
        <div className={`side-nav-mobile ${context.mobileToggle ? 'show-mobile-drop' : ''}`}>
          <div className={`d-flex flex-row ${context.mobileToggle ? 'inverted' : ''}`} role="none">

            <Banner
              isMobile = {context.isMobile}
              isCollapsed = {isCollapsed}
              isB2C = {isB2C}
              referenceId = {referenceId}
              whiteLabelBranding={get(contentFragment.banner, 'whiteLabelBranding')}
              variant="SECONDARY"
              manulifeBranding={get(contentFragment.banner, 'manulifeBranding')}
              organizationCategory={userProfile.organizationCategory}
              hasLogo={!!userProfile.whiteLabel?.logoFile}
              organizationName={`${userProfile[`organizationName${config.locale.toUpperCase()}`]} (${userProfile.organizationCode})`}
              userProfile={userProfile}
            />
            <NavigationButtonsDesktop
              contactUs={contactUs}
              languageInfo={languageInfo}
              menuList={menuList}
              onSelect={onSelect}
              onLanguageToggle={onLanguageToggle}
            />
          </div>
        </div>
      ) : (
        <NavigationButtonsDesktop
          contactUs={contactUs}
          languageInfo={languageInfo}
          menuList={menuList}
          onSelect={onSelect}
          onLanguageToggle={onLanguageToggle}
        />
      )}
    </div>
  );
};

export interface ResponsiveTopNavProps extends NavMenu {
  organizationCode?: string;
  isAdmin?: boolean;
  organizationDropDownList?: {
    label: string;
    value: string;
  }[];
  searchOrganizations?: (str: string) => [];
  organizationSelectionChange?: (val: string) => void;
  organizationText?: string;
}

export const ResponsiveTopNav: FC<ResponsiveTopNavProps> = props => {
  return (
    <NavContextProvider defaultActive={props.defaultSelected} items={props.menuList} onSelect={props.onSelect}>
      <nav className="top-nav-responsive-mobile" data-testid="top-nav">
        <NavigationResponsive {...props} />
      </nav>
    </NavContextProvider>
  );
};

ResponsiveTopNav.displayName = 'ResponsiveTopNav';
export default ResponsiveTopNav;
